import React from 'react';
import Card from '@material-ui/core/Card'
import CardMedia from '@material-ui/core/CardMedia'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import {
    Link
  } from "react-router-dom";
import { withRouter } from 'react-router-dom';
import { format, parseISO } from 'date-fns'

const useStyles = makeStyles(theme => ({
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
      },
    buttonContainer: {
        textAlign: 'center',
    },
    loadingContainer: {
        marginTop: '50%'
    },
}));

function VideoCard(props) {
    const classes = useStyles();

    let linearProgress = null;
    let description = null;
    let ReadingMaterialsUrl = null;

    if(props.timestamp != null) {
        linearProgress = <LinearProgress style={{align:'center', height: '20px'}} variant="determinate" value={(props.timestamp / props.VideoLength) * 100} />
    }

    if(props.Description && props.Description.length > 0) {
        description =
        <Box ml={2} mr={2}>
            <Typography variant="body1" gutterBottom>
                <div><strong>Description:</strong> {props.Description} </div>
            </Typography>
        </Box>;
    }

    if(props.ReadingMaterialsUrl && props.ReadingMaterialsUrl.length > 0) {
        ReadingMaterialsUrl =
        <Box mb={2} ml={2} mr={2}>
            <Typography variant="body1" gutterBottom>
                <div><a href={props.ReadingMaterialsUrl} target="_blank">CLE Reading Materials</a></div>
            </Typography>
        </Box>;
    }

    console.log(props.currentRoute);
    return (
      <Box mb={3}>
        <Card>
            <Grid container spacing={4}>
                <Grid item xs={12} md={3}>
                    <Link to={props.completed ? "watch/" + props.vid + "/replay" : "watch/" + props.vid}>
                        <CardMedia
                            className={classes.media}
                            image={"https://img.youtube.com/vi/" + props.vid + "/mqdefault.jpg"}
                            title={props.title}
                        />
                    </Link>
                </Grid>
                <Grid item xs={12} md={9}>
                    <Box mb={2} ml={2} mr={2}>
                        <Link style={{color:'Black', textDecoration: 'none' }} to={props.completed ? "watch/" + props.vid + "/replay" : "watch/" + props.vid} currentPath={props.currentRoute}><Typography variant="h4" component="h2">{props.title}</Typography></Link>
                    </Box>
                    <Box mb={2} ml={2} mr={2}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>   
                                <Grid container spacing={0} align="center" justify="center" >
                                    <Grid item xs={12} sm={7} align="left" justify="center">
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} align="left" justify="center">
                                                <Typography variant="subtitle1" >
                                                    <div><strong>Length:</strong> {new Date(props.VideoLength * 1000).toISOString().substr(11, 8)}</div>
                                                    <div><strong>CLE Credit:</strong> {props.CLECredit}</div>
                                                    <div><strong>Expires On:</strong> {format(parseISO(props.ExpirationDate), 'MMM d, yyyy')} </div>
                                                    <div><strong>Credit Type:</strong> {props.CreditType} </div>
                                                </Typography>                                            
                                            </Grid>                
                                            <Grid item xs={8} align="left" justify="center">
                                                {linearProgress}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        <Grid container spacing={2}>
                                            <Grid item>
                                                {props.timestamp != null ?
                                                    <Link style={{color:'Black', textDecoration: 'none' }} to={"watch/" + props.vid} currentPath={props.currentRoute}>
                                                        <Button fullwidth variant="contained" size="large" color="primary">
                                                            Resume
                                                        </Button>
                                                    </Link>
                                                :
                                                    <Link style={{color:'Black', textDecoration: 'none' }} to={"watch/" + props.vid} currentPath={props.currentRoute}>
                                                        <Button fullwidth variant="contained" size="large" color="primary">
                                                            Play
                                                        </Button>
                                                    </Link>
                                                }
                                            </Grid>
                                            <Grid item>
                                                {props.authToken &&
                                                    <React.Fragment>
                                                        {props.DateSubmitted != null && props.QuikPayId != null?
                                                            <Typography>Submitted on<br />{format(parseISO(props.DateSubmitted), 'MMM d, yyyy')}</Typography>
                                                            :
                                                            <Link style={{color:'Black', textDecoration: 'none' }} to={"apply/" + props.vid} currentPath={props.currentRoute}>
                                                                <Button fullwidth variant="contained" size="large" color="secondary">
                                                                    Apply for CLE
                                                                </Button>
                                                            </Link>
                                                        }
                                                    </React.Fragment>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    {description}
                    {ReadingMaterialsUrl}
                </Grid>
            </Grid>
        </Card>
    </Box>
  );
}
export default withRouter(VideoCard);